import React, { useEffect, useRef, useState } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import "bootstrap-icons/font/bootstrap-icons.css";
import ReactPaginate from "react-paginate";
import Table from "../../../constants/Table";
import AddProject from "./AddProject";
import { useNetwork } from "../../../context/NetworkContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useShowAlert } from "../../../context/AlertContext";
import { useNavigate } from "react-router-dom";
import { AddIcon, DeleteIcon, RefreshIcon, SearchIcon } from "../../../constants/Icons";

const ListProject = ({ isActive }) => {
  const navigate = useNavigate();
  const [isSearchTerm, setSearchTerm] = useState("");
  const containerRef = useRef(null);
  const [projects, setProjects] = useState([]);
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [hasSearched, setHasSearched] = useState(false);
  const [ProductSuggestions, setProductSuggestions] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const searchInputRef = useRef(null);
  const suggestionRefs = useRef([]);
  const requestIdRef = useRef(0);
  const [isPreLoading, setPreLoading] = useState(false);
  const [status, setStatus] = useState("pending");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [isBtnLoading, setBtnLoading] = useState({
    list: false,
    add: false,
  });
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const perPage = 10;
  const handleOpenModal = () => {
    setEditData(null);
    setModalOpen(true);
  };

  const openEditModal = (item) => {
    setEditData(item);
    setModalOpen(true);
  };

  const closeEditModal = () => {
    setModalOpen(false);
    setEditData(null);
  };

  const openviewModal = (id) => {
    handleProjectView(id);
  };
  const openDeleteModal = (id) => {
    // if (window.confirm("Are you sure you want to delete this project?")) {
    //   setProjects((prev) => prev.filter((p) => p._id !== id));
    // }
  };

  const filteredProjects = projects.filter((proj) =>
    (proj.name || "").toLowerCase().includes(isSearchTerm.toLowerCase()),
  );

  const getCounts = (statusKey) =>
    projects.filter((p) => p.status === statusKey).length;

  useEffect(() => {
    if (!isActive) return;
    const timer = setTimeout(() => {
      searchInputRef.current?.focus();
    }, 0);
    return () => clearTimeout(timer);
  }, [isActive]);

  const columns = [
    {
      label: "S No",
      render: (item, index) => projects.length - index,
    },
    {
      label: "Title",
      render: (item) =>
        item?.name
          ? item.name.charAt(0).toUpperCase() + item.name.slice(1)
          : "-",
    },
    {
      label: "Date",
      render: (item) =>
        item?.createdAt
          ? DateConverter.ISOToDisplayFormat(item.createdAt).date
          : "-",
    },
    {
      label: "Action",
      render: (item) => (
        <div className="order-actions opacity-0 opacity-md-100">
          {/* <button
            type="button"
            className="btn-label-primary shadow-none me-2"
            onClick={(e) => {
              e.stopPropagation();
              openEditModal(item);
            }}
          >
            <i className="ng ng-ng-edit-icon"></i>
          </button> */}
          <button
            type="button"
            className="btn-label-danger shadow-none me-2"
            onClick={(e) => {
              e.stopPropagation();
              openDeleteModal(item);
            }}
          >
            <DeleteIcon/>
          </button>
        </div>
      ),
    },
  ];
  const handleProjectList = async (page = 0) => {
    setBtnLoading((prev) => ({ ...prev, list: true }));
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/project?pageno=${page + 1}&limit=${perPage}`,
      );
      const results = response.data.results || [];
      setProjects(results);
      if (results.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading((prev) => ({ ...prev, list: false }));
    }
  };

  const handleProjectView = (id) => {
    navigate("/ViewProject", {
      state: { projectId: id },
    });
  };

  const handleRefresh = async () => {
    handleProjectList(currentPage);
  };
  const handleSearch = (term) => {
    const upperTerm = term.toLowerCase(); // ✅ Convert to uppercase
    setSearchTerm(upperTerm);
    setHasSearched(true);

    if (!upperTerm.trim()) {
      setProductSuggestions([]);
      setCurrentPage(0);
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    debounceTimerRef.current = setTimeout(async () => {
      try {
        if (!checkNetwork()) return;
        setSuggestionLoading(true);

        controllerRef.current = new AbortController();
        const currentId = ++requestIdRef.current;
        const response = await AxiosInstance.get(
          `module/project/search?searchtxt=${upperTerm}`,
          { signal: controllerRef.current.signal },
        );
        if (currentId === requestIdRef.current) {
          setProductSuggestions(response.data.results || []);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
      } finally {
        setSuggestionLoading(false);
      }
    }, 200);
  };
  const handleSuggestionNavigation = (e) => {
    if (e.key === "Enter") {
      if (activeIndex >= 0 && ProductSuggestions[activeIndex]) {
        e.preventDefault();
        openEditModal(ProductSuggestions[activeIndex]);
      }
      // else {
      //   e.preventDefault();
      //   handleSearchFind();
      // }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < ProductSuggestions.length - 1 ? prev + 1 : 0,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : ProductSuggestions.length - 1,
      );
    }
  };
  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);
  useEffect(() => {
    handleProjectList(currentPage);
  }, []);
  const handleSuggestionClick = (product) => {
    setSearchTerm(product.name);
    setProductSuggestions([]);
    setHasSearched(false);
    setActiveIndex(-1);
    handleProjectView(product._id);
  };
  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="row">
              <div className="breadcrumb-title pe-3 d-flex align-items-center gap-2">
                <div className="pb-1">
                  <button
                    type="button"
                    className="btn btn-sm btn-light p-1 shadow-none"
                    onClick={handleRefresh}
                    disabled={isPreLoading}
                    title="Refresh list"
                  >
                    <RefreshIcon iClass={`${isPreLoading ? "bx-spin" : ""}`}/>
                  </button>
                </div>
                <div className="breadcrumb-title pe-3">List Project</div>
              </div>
            </div>

            <div className="card radius-10 mb-0 mt-2">
              <div className="row g-0">
                {/* Left Column Controls */}
                <div className="col-md-3 col-lg-2 border-end">
                  <div className="p-3">
                    <button
                      type="button"
                      onClick={handleOpenModal}
                      className="btn w-100 mb-3 btn-project"
                    >
                      <AddIcon iClass={"me-1"}/> New Project
                    </button>

                    {[
                      {
                        key: "pending",
                        label: "List Project",
                        icon: "bi bi-hourglass-split",
                        color: "bg-label-blue",
                      },
                      // {
                      //   key: "inprogress",
                      //   label: "In Progress",
                      //   icon: "bi bi-arrow-repeat",
                      //   color: "bg-label-primary",
                      // },
                      // {
                      //   key: "ready",
                      //   label: "Ready",
                      //   icon: "bi bi-check2-circle",
                      //   color: "bg-label-blue",
                      // },
                      // {
                      //   key: "delivered",
                      //   label: "Delivered",
                      //   icon: "bi bi-truck",
                      //   color: "bg-label-green",
                      // },
                      // {
                      //   key: "cancelled",
                      //   label: "Cancelled",
                      //   icon: "ng ng-ng-delete-icon",
                      //   color: "bg-label-danger",
                      // },
                    ].map((opt) => (
                      <button
                        key={opt.key}
                        className={`btn w-100 text text-start d-flex justify-content-between align-items-center mb-1
                        ${status === opt.key ? opt.color + " text-white" : "text-muted"}`}
                        onClick={() => {
                          setStatus(opt.key);
                          setCurrentPage(0);
                        }}
                        style={{
                          border: "none",
                          boxShadow: "none",
                          transition: "background 0.2s ease",
                        }}
                      >
                        <span>
                          <i className={`${opt.icon} me-1`}></i> {opt.label}
                        </span>
                        {getCounts(opt.key) > 0 && (
                          <span className="badge rounded-pill bg-label-project">
                            {getCounts(opt.key)}
                          </span>
                        )}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Right Table Container Panel */}
                <div className="col-md-9 col-lg-10">
                  <div className="p-3">
                    <div className="row">
                      <div className="col-lg-4 col-12 mb-2">
                        <div className="position-relative">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              ref={searchInputRef}
                              value={isSearchTerm}
                              onChange={(e) => {
                                handleSearch(e.target.value);
                                setActiveIndex(-1);
                              }}
                              onKeyDown={handleSuggestionNavigation}
                              placeholder="Search Project ..."
                              autoFocus
                            />
                            <button className="input-group-text">
                              <SearchIcon/>
                            </button>
                          </div>
                          {hasSearched &&
                            isSearchTerm &&
                            !suggestionLoading &&
                            ProductSuggestions.length === 0 && (
                              <ul className="suggestions-list">
                                <li className="suggestion-item text-muted">
                                  No Project data was found
                                </li>
                              </ul>
                            )}
                          {ProductSuggestions.length > 0 && (
                            <ul className="suggestions-list">
                              {ProductSuggestions.map((product, index) => (
                                <li
                                  key={product._id}
                                  ref={(el) =>
                                    (suggestionRefs.current[index] = el)
                                  }
                                  onClick={() => handleSuggestionClick(product)}
                                  // onClick={() => openEditModal(product)}
                                  className={`suggestion-item ${
                                    index === activeIndex
                                      ? "active-suggestion"
                                      : ""
                                  }`}
                                >
                                  <span className="text-black">
                                    {product.name}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    </div>

                    <div ref={containerRef}>
                      <Table
                        loading={isBtnLoading.list}
                        columns={columns}
                        data={filteredProjects}
                        onRowClick={(item) => handleProjectView(item._id)}
                      />
                    </div>
                    <div className="row align-items-center mt-3">
                      <div className="col text-center">
                        {totalPages > 0 && (
                          <ReactPaginate
                            previousLabel={"← Previous"}
                            nextLabel={"Next →"}
                            breakLabel={"..."}
                            onPageChange={({ selected }) => {
                              setPreLoading(true);
                              setCurrentPage(selected);
                              handleProjectList(selected);
                            }}
                            pageRangeDisplayed={5}
                            pageCount={totalPages}
                            containerClassName="pagination justify-content-center mb-0"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            activeClassName="active"
                            forcePage={currentPage}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isModalOpen && (
            <AddProject
              isActive={isActive}
              onClose={closeEditModal}
              setProjects={setProjects}
              editData={isEditData}
              setBtnLoading={setBtnLoading}
              isBtnLoading={isBtnLoading}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ListProject;
